import React, { useState } from "react";
import emailjs from "emailjs-com";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(() => ({
  formContainer: {
    //border: "1px solid",
  },
}));

function FeedbackForm({
  email,
  setEmail,
  feedback,
  setFeedback,
  errorMessage,
  sendEmail,
}) {
  return (
    <Grid item sm={8} xs={12}>
      <Typography variant="h6" gutterbottom color="textSecondary">
        Get in touch with us
      </Typography>
      <form onSubmit={sendEmail}>
        <TextField
          variant="outlined"
          label="Email"
          fullWidth
          placeholder="Enter email"
          error={errorMessage.type === "email" && true}
          helperText={errorMessage.type === "email" && errorMessage.message}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginTop: "1rem" }}
          name="email"
        />
        <TextField
          variant="outlined"
          label="Message"
          fullWidth
          multiline
          rows={5}
          value={feedback}
          error={errorMessage.type === "feedback" && true}
          helperText={errorMessage.type === "feedback" && errorMessage.message}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Enter message or bugs/suggetions for future versions"
          style={{ marginTop: "1rem" }}
          name="message"
        />
        <Grid style={{ marginTop: "1rem", display: "flex" }}>
          <Button style={{ marginLeft: "auto" }} color="secondary" type="reset">
            Reset
          </Button>
          <Button variant="contained" color="secondary" type="submit">
            Send
          </Button>
        </Grid>
      </form>
    </Grid>
  );
}

export default FeedbackForm;
